<style>
	.joinBox{
	  position: absolute;
	  width:100%;
	  left:0;
	  top:60px;
	  margin:auto;
    min-width:1440px;
	  bottom: 0;
	  min-height: 400px;
	}
	.bg{
	  height:100%;
	  width:100%;
	  position: absolute;
	  left:0;
	  top:0;
	}
	.aboutContainer{
	  height:211px;
	  width:100%;
	  position: absolute;
	  top:0;
	  bottom: 60px;
	  text-align: center;
	  margin:auto;
	}

  .aboutContainer p:nth-child(1){
    height:56px;
    font-size:26px;
    font-family:PingFang SC;
    line-height:56px;
    color:rgba(51,51,51,1);
  }
  .aboutContainer p:nth-child(1) span{
   font-size: 30px;font-weight: bold;
  }

  .aboutContainer p:nth-child(2){
    height:33px;
    font-size:24px;
    font-family:PingFang SC;
    /* font-weight:bold; */
    margin-top:45px;
    line-height: 33px;
    color:rgba(51,51,51,1);
  }
  .aboutContainer p:nth-child(3){
    height:33px;
    font-size:24px;
    font-family:PingFang SC;
    /* font-weight:bold; */
    margin-top:45px;
    line-height: 33px;
    color:rgba(51,51,51,1);
  }
  .bg[name='mobile']{
    display: none;
  }

  @media screen and (max-width:500px ) {
    .joinBox{
      top:40px;
      min-width:0;
    }
    .bg[name='mobile']{
      display: block;
    }
    .bg[name='pc']{
      display: none;
    }
	.aboutContainer{

	  bottom:0;

	}

    .aboutContainer p:nth-child(1){
      height:24px;
      font-size:17px;
      font-family:PingFang SC;
      line-height:24px;
      color:rgba(51,51,51,1);
      font-weight: bold;
    }

    .aboutContainer p:nth-child(1) span{
     font-size: 17px;font-weight: bold;
    }
    .aboutContainer p:nth-child(2){
      height:auto;
      font-size:14px;
      font-family:PingFang SC;
      /* font-weight:bold; */
      margin-top:18px;
      line-height: 26px;
      color:rgba(51,51,51,1);
      font-weight: bold;
    }
    .aboutContainer p:nth-child(3){
      height:20px;
      font-size:14px;
      font-family:PingFang SC;
      /* font-weight:bold; */
      margin-top:20px;
      line-height: 20px;
      color:rgba(51,51,51,1);
      font-weight: bold;
    }
  }

</style>

<template>
	<div class='joinBox'>
	  <img class='bg' src="../assets/aboutus.png" alt="" name='pc'>
    <img class='bg' src="../assets/about_mobile.png" alt="" name='mobile'>
	  <div class='aboutContainer'>
      <p>柜柜全国用户 <span v-if='userNum!=0'>{{userNum}}个</span></p>
      <p>想要购买全屋定制家具<br>到工厂，更便宜，发货速度快，售后有保障</p>
      <p>柜柜厂，给老百姓省钱，为工厂创收</p>
	  </div>
	</div>
</template>

<script>
	export default {
		components:{

		},
		props:[],
		data() {
			return {
        userNum:0
			}
		},
		computed: {

		},
		mounted() {
      let that=this
      // that.axios({
      //   url:"https://guigui.admin.thinkerx.com/eggrj/user_count"
      // }).then(resp=>{
      //   let res=resp.data
      //   that.userNum=res.data.res
      // })
      that.$post("/system/eggrj/user_count",{},resp => {
        that.userNum = resp.data.res
      })
		},
		methods: {

		}
	}
</script>
